module.exports = __webpack_public_path__ + "img/RAQ-not-eligible-img-desktop-only@2x.d2021a8e.png";